var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.schema.fieldName, _vm.getSelectedDEV && 'dev-selected-component']},[_c('vueper-slides',_vm._b({staticClass:"no-shadow"},'vueper-slides',_vm.schema.attributesCarousels,false),_vm._l((_vm.schema.items),function(slide,i){return _c('vueper-slide',{key:i,attrs:{"image":slide.image,"href":slide.image}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }